module.exports = __webpack_public_path__ + "img/time_entries_empty.c7713b03.svg";